import React from "react";

import AlumniSection from "../../components/home/alumniSection";
import CountryWithPrograms from "../../components/home/country-hub/CountryWithPrograms";
import FeaturedBlog from "../../components/home/featured-blog/FeaturedBlog";
import HomeBanner from "../../components/home/homeBanner";
import HomeIntro from "../../components/home/homeIntro";
import IssueSlider from "../../components/home/issue-slider";
import OpenDay from "../../components/home/open-day";
import ScholarshipBanner from "../../components/home/scholarshipBanner";
import TrustedPartners from "../../components/home/trustedPartners";
import Newsletter from "../../components/newsletter";
import { useBannerDetails } from "../../hooks/useBannerManager";
import { useGviconfigurator } from "../../hooks/useSiteConfigurator";
import { formatHeroBackgroundOptions } from "../../utils/formatContent";

export default function HomePageComponent({ data, localeLanguage, colorMode }) {
  const { page, genericDetails } = data;

  const heroOpts = formatHeroBackgroundOptions(page?.globalConfig);
  const heroGatsbyBackgroundImage = heroOpts?.gatsby_image.desktop;

  const heroGatsbyBackgroundImageMobile =
    heroOpts?.gatsby_image.mobile && heroOpts?.gatsby_image.mobile?.gatsbyImage
      ? heroOpts?.gatsby_image.mobile?.gatsbyImage
      : heroGatsbyBackgroundImage;

  const heroBackgroundImage = heroOpts?.image?.desktop;

  const heroBackgroundImageMobile = heroOpts?.image?.mobile;

  const heroBackgroundVideo = heroOpts?.video?.desktop;
  const heroOverlayTitle = page?.acfLandingPage?.genHeaderOverlayTitle ?? "";
  const heroDesc = page?.acfLandingPage?.genHeaderOverlayDesc ?? "";
  const mobileDesc = page?.acfLandingPage?.genHeaderOverlayMobileDesc ?? "";

  const heroCTATitle =
    page?.acfLandingPage?.genHeaderOverlayCtaDesc ?? "watch the FULL movie";
  const heroFullVideo = page?.acfLandingPage?.genHeaderOverlayFullMovie ?? "";

  const genericGlobalConfig =
    genericDetails?.globalProgramConfig?.acfGenericGlobalConfig ?? {};

  const scholarshipTitle =
    genericGlobalConfig?.exclusiveOfferTitle ??
    "Get up to EXCLUSIVE_OFFER off your program";
  const scholarshipDescription =
    genericGlobalConfig?.exclusiveOfferDescription ??
    "When you join a climate research internship by 30 November";
  const scholarshipCtaLink =
    genericGlobalConfig?.exclusiveOfferLink ?? "/application-form";

  const configurator = useGviconfigurator();
  const { grants_banner_config } = configurator ?? {};

  const ukHomebannerConfig = grants_banner_config?.homepage ?? {};

  const banner = useBannerDetails(page?.slug, "homepage");

  //replace title with banner title if available
  const displayBannerTitle = banner?.title || "";

  const displayBannerDesc = banner?.desc || "";

  return (
    <div className="page-home">
      <HomeBanner
        heroTitle={heroOverlayTitle}
        heroCTATitle={heroCTATitle}
        heroDesc={heroDesc}
        mobileDesc={mobileDesc}
        featureVideoId={heroFullVideo}
        videoId={heroBackgroundVideo}
        heroImage={heroBackgroundImage}
        heroGatsbyImage={heroGatsbyBackgroundImage}
        heroImageMobile={heroBackgroundImageMobile}
        heroGatsbyImageMobile={heroGatsbyBackgroundImageMobile}
      />
      <HomeIntro />

      <ScholarshipBanner
        scholarships={[]}
        scholarshipBackgroundImage={null}
        scholarshipFeatureImage={banner?.image}
        scholarshipTitle={displayBannerTitle ?? scholarshipTitle}
        scholarshipDescription={displayBannerDesc ?? scholarshipDescription}
        scholarshipCtaLink={scholarshipCtaLink}
        scholarshipCtaLabel={ukHomebannerConfig?.ctaLabel ?? "Apply"}
      />

      <IssueSlider />

      <CountryWithPrograms />

      <AlumniSection />

      <FeaturedBlog />

      <OpenDay key={"upcoming-open-day-slides"} />

      <TrustedPartners key={"trusted-partners-key"} />

      <Newsletter />
    </div>
  );
}
